<template>
	<v-app>

	</v-app>
</template>

<script>
export default {
	name:"MaintainerDashboard"
}
</script>